import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateTemplateInvestment($data: CreateTemplateInvestmentInput!) {
    createTemplateInvestment(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createTemplateInvestment: {
    id: number;
  };
}
